<template>
 <div class="l-info-title" :class="type">
    <h2 class="content" >
        {{ title }}
        <slot /> 
    </h2>
 </div>
 
</template>

<script>
export default {
    name: 'l-info-title',
    props:{
        type:{
            default: 'def'
        },
        title: {
            default:''
        }
    }

}
</script>
<style lang="scss" scoped>
.l-info-title{
    
    @include font_sub_title;

    .content{
        display: inline-block;
        padding-bottom: 26px;
        position: relative;
    }

    &.def{
        
        .content::after{
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            margin: auto;
            width: 40px;
            height: 2px;
            background: $main_color;
        }
    }
    
    &.center{
        text-align: center;

        .content::after{
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

            margin: auto;
            width: 40px;
            height: 2px;
            background: $main_color;
        }
        
    }
    
}

</style>